var map = {
	"./1-blue.png": "NJ1G",
	"./1.png": "Txl5",
	"./222.png": "XboF",
	"./Contact-blue.png": "wzty",
	"./Contact-info.png": "jGXK",
	"./Contact.png": "QCTk",
	"./Testimonial-blue.png": "Kw8H",
	"./Testimonial.png": "bGw/",
	"./Testimonial1-blue.png": "R3qm",
	"./Testimonial1.png": "XiGS",
	"./Testimonial2-blue.png": "Y0SP",
	"./Testimonial2.png": "tH18",
	"./about-bg-blue.png": "rYYn",
	"./about-bg.png": "j313",
	"./aboutus.png": "6uiW",
	"./app/01.jpg": "BOhW",
	"./app/02.jpg": "FYzy",
	"./app/03.jpg": "pRQa",
	"./app/04.jpg": "M/Qp",
	"./app/05.jpg": "1Gk9",
	"./app/1.jpg": "yZ2I",
	"./app/10.jpg": "8aBu",
	"./app/11.jpg": "1IZE",
	"./app/12.jpg": "kvhG",
	"./app/13.jpg": "AQC5",
	"./app/14.jpg": "osO2",
	"./app/15.jpg": "SWZ5",
	"./app/16.jpg": "5VkT",
	"./app/17.jpg": "ORmL",
	"./app/2.jpg": "RYWd",
	"./app/3.jpg": "wBqP",
	"./app/4.jpg": "VdFB",
	"./app/5.jpg": "mwEt",
	"./app/6.jpg": "Nv0Y",
	"./app/7.jpg": "FYhk",
	"./app/8.jpg": "arkn",
	"./app/9.jpg": "LUKC",
	"./appstore.png": "Rf8H",
	"./auth-bg-blue-png.png": "E0JE",
	"./auth-bg-blue.png": "a5jd",
	"./auth-bg.jpg": "9lqd",
	"./auth-bg.png": "d7Qf",
	"./avtar/1.jpg": "F80L",
	"./avtar/15.jpg": "OPXd",
	"./avtar/22.jpg": "sDxD",
	"./back.png": "DtD7",
	"./blog/1.jpg": "LA5K",
	"./blog/10.jpg": "OeJB",
	"./blog/2.jpg": "8ZQi",
	"./blog/3.jpg": "gp7d",
	"./blog/6.jpg": "jtnm",
	"./blog/7.jpg": "uH2u",
	"./blog/8.jpg": "URVa",
	"./blog/9.jpg": "uwYJ",
	"./blog/blog-comment-three.jpg": "3//O",
	"./blog/blog-comment-two.jpg": "P7ej",
	"./blog/blog-comment.jpg": "Quc0",
	"./blog/blog-details.jpg": "49OC",
	"./blog/blog3.jpg": "4fKA",
	"./browsers/chrome.png": "iB4l",
	"./browsers/firefox.png": "yOtu",
	"./browsers/ie.png": "uqIx",
	"./browsers/opera.png": "xqxY",
	"./browsers/safari.png": "OAVQ",
	"./company/banks.png": "FGMK",
	"./company/fin.png": "ORgK",
	"./company/it.png": "YmdH",
	"./company/partners.png": "JKs2",
	"./company/sp.png": "9tlV",
	"./company/time.png": "+Qwd",
	"./demo/404.png": "tws9",
	"./demo/blog-details-with-leftsidebar.jpg": "ZiR9",
	"./demo/blog-details-with-rightsidebar.jpg": "iFDl",
	"./demo/blog-details.jpg": "sAU5",
	"./demo/blog.jpg": "cwzX",
	"./demo/blogs-leftside.jpg": "dNFu",
	"./demo/blogs-rightside.jpg": "rjGn",
	"./demo/coming-soon.png": "MnSi",
	"./demo/download.png": "/POV",
	"./demo/email.png": "h78I",
	"./demo/faq.png": "AXP+",
	"./demo/forget-pwd.png": "06Ea",
	"./demo/index-2.jpg": "g71+",
	"./demo/index-3.jpg": "Xgz1",
	"./demo/index.jpg": "M7fv",
	"./demo/review.png": "B7aC",
	"./demo/sign-in.png": "b5fc",
	"./demo/sign-up.png": "teDP",
	"./demo/thank-you.png": "6akV",
	"./down-blue.png": "XrxW",
	"./down.png": "rix4",
	"./email-blue.png": "84rs",
	"./email.png": "vCvB",
	"./email/facebook-email.png": "8Lla",
	"./email/feed.png": "I5gV",
	"./email/google.png": "oUd3",
	"./email/instagram-email.png": "gJwI",
	"./email/twitter-email.png": "tKhp",
	"./error/cloud-bg-1.png": "CQE+",
	"./error/cloud-bg-2 - Copy.png": "M8Pn",
	"./error/cloud-bg-2.png": "q/eM",
	"./error/sad.png": "a2bI",
	"./favicon.png": "1H3f",
	"./fax.png": "vBzX",
	"./feature-bg-blue.png": "Rdht",
	"./feature-bg.png": "Xhqm",
	"./feature-circle-blue.png": "sNh+",
	"./feature-circle-two-blue.png": "qnXz",
	"./feature-circle-two.png": "KZrA",
	"./feature-circle.png": "mkW3",
	"./feature2-blue.png": "FpkB",
	"./feature2.png": "fnNz",
	"./features/all-broweser-support.png": "cvPG",
	"./features/animate-css.png": "dDoi",
	"./features/bootstrap-4.png": "5slL",
	"./features/color-management.png": "MnNr",
	"./features/css-3.png": "dBHD",
	"./features/fullpage-js.png": "kppf",
	"./features/google-fonts-support.png": "Y2nW",
	"./features/google-map.png": "UT53",
	"./features/html5.png": "CRM7",
	"./features/multiple-blog-layouts.png": "Dy2W",
	"./features/pixel-perfect-design.png": "w5QQ",
	"./features/responsive.png": "ZQ0r",
	"./features/social-links.png": "tB4H",
	"./features/three-type-home-page.png": "Qds5",
	"./features/typography.png": "jGQG",
	"./features/vue.png": "8NSn",
	"./features/w3c-validation.png": "XMwm",
	"./feedbacks/1.jpg": "PEkz",
	"./feedbacks/2.jpg": "2XPM",
	"./feedbacks/3.jpg": "xthu",
	"./feedbacks/4.jpg": "UXgR",
	"./feedbacks/5.jpg": "m7bB",
	"./feedbacks/empty.jpg": "ZvAE",
	"./fotter-email.png": "phIc",
	"./home2/home2-slider.png": "s6ax",
	"./home2/logo-icon.png": "rmmc",
	"./home2/logo.png": "ZVat",
	"./home2/play-button.png": "BZ8Q",
	"./home2/slider-caption.png": "IXWz",
	"./home3/home-3-img.png": "QXWg",
	"./home3/home3-slider.png": "4gOx",
	"./icon/1.png": "nYED",
	"./icon/2.png": "XaML",
	"./icon/3.png": "k0u4",
	"./icon/4.png": "AOVd",
	"./icon/5.png": "2d/n",
	"./icon/6.png": "xchJ",
	"./icon1.png": "d0yY",
	"./icon2.png": "ceFa",
	"./icon3.png": "akCb",
	"./icon4.png": "72gb",
	"./instagram-blue.png": "wwPe",
	"./instagram.png": "JGRZ",
	"./landing-logo.png": "VZdp",
	"./landing/1.png": "93zg",
	"./landing/2.png": "Zuxj",
	"./landing/3.png": "6PZE",
	"./landing/4.jpg": "ZRV8",
	"./landing/5.jpg": "A1OO",
	"./landing/6.jpg": "vhxb",
	"./landing/template.png": "FeVF",
	"./lannd-bg-blue.png": "CZsb",
	"./lannd-bg.png": "DKzj",
	"./light-right.png": "cDCj",
	"./light.png": "77ig",
	"./locate.png": "I7T+",
	"./logo.png": "iQH9",
	"./logoimage.png": "rEiP",
	"./mac.png": "WMFF",
	"./mail.png": "8ni1",
	"./main-banner1-blue.png": "ylKT",
	"./main-banner1.png": "zeIt",
	"./main-banner12-blue.png": "tzto",
	"./main-banner12.png": "+gyt",
	"./main-banner3-blue.png": "TiAH",
	"./main-banner3.png": "jS8J",
	"./mediamodifier_image.png": "vDpe",
	"./mediamodifier_image_2.png": "b96o",
	"./mediamodifier_image_3.png": "2KJD",
	"./message.png": "Sbtz",
	"./mobile.png": "HXsc",
	"./mockups/appsMockupLeft.png": "CIJ+",
	"./mockups/appsMockupRight.png": "Ds+o",
	"./mockups/mainMockupLeft.png": "OFN0",
	"./mockups/mainMockupRight.png": "obYc",
	"./mockups/screenshots/0.jpg": "wnle",
	"./mockups/screenshots/1.jpg": "RsMm",
	"./mockups/screenshots/2.jpg": "ZtR2",
	"./mockups/screenshots/3.jpg": "Kbmo",
	"./mockups/screenshots/4.jpg": "PXf+",
	"./mockups/screenshots/5.jpg": "sGUK",
	"./mockups/screenshots/6.jpg": "Zoti",
	"./mockups/screenshots/phone.png": "iuBH",
	"./next.png": "3aVt",
	"./notebook.png": "soRz",
	"./notebook_right.png": "Jlw1",
	"./notebook_right_2.png": "S65s",
	"./numbers/0.svg": "buJT",
	"./numbers/1.svg": "NxHL",
	"./numbers/2.svg": "NC3X",
	"./numbers/3.svg": "gxIt",
	"./numbers/4.svg": "WduV",
	"./numbers/5.svg": "zwzX",
	"./numbers/6.svg": "/tgb",
	"./numbers/7.svg": "0Inm",
	"./numbers/8.svg": "AzDb",
	"./numbers/9.svg": "Z41b",
	"./partners/Abank.png": "ldXE",
	"./partners/Alliance.png": "iiMW",
	"./partners/Creditagricole.png": "rkgs",
	"./partners/Creditagricole.svg": "lCza",
	"./partners/Globus.png": "wBFI",
	"./partners/Km.png": "jTJD",
	"./partners/Km.svg": "M8lX",
	"./partners/Otp.png": "D9Hl",
	"./partners/Otp.svg": "hz5G",
	"./partners/Pumb.png": "l4+g",
	"./partners/SenseBank.png": "j1g9",
	"./partners/SenseBank.svg": "m7ob",
	"./partners/Sf.png": "A4NY",
	"./partners/Superium.png": "d/fQ",
	"./partners/Superium.svg": "Txu0",
	"./partners/Ukrsib.png": "IRkC",
	"./partners/Unex.png": "QC1H",
	"./partners/Unex.svg": "1FTF",
	"./partners/nets/33м2.png": "nKu3",
	"./partners/nets/Allo.png": "QwuR",
	"./partners/nets/Appleroom.png": "fTyN",
	"./partners/nets/Boschsiemens.png": "J6fL",
	"./partners/nets/Compvsesvit.png": "3u0k",
	"./partners/nets/DeWise.png": "5rcF",
	"./partners/nets/Dmtehnika.png": "a6Zd",
	"./partners/nets/Dmtehnika.svg": "BfPk",
	"./partners/nets/Eldorado.png": "yzuf",
	"./partners/nets/Expert.png": "c2gE",
	"./partners/nets/Juke.png": "Qgco",
	"./partners/nets/KTC.png": "XObV",
	"./partners/nets/MT.png": "i5lZ",
	"./partners/nets/Moyo.png": "wEKo",
	"./partners/nets/Orbita.png": "jkUA",
	"./partners/nets/Ringoo.png": "iw27",
	"./partners/nets/Samsung.png": "8RJA",
	"./partners/nets/Smartshop.png": "+dfH",
	"./partners/nets/Sota.png": "KFGG",
	"./partners/nets/Tehnomarket.png": "ijQI",
	"./partners/nets/Tehnoprostir.png": "T5lh",
	"./partners/nets/Tehnotop.png": "URxw",
	"./partners/nets/Ttt.png": "qVtv",
	"./partners/nets/Volti.png": "eM36",
	"./partners/nets/Yabko.png": "OzKw",
	"./phone.png": "JhOT",
	"./placeholder.png": "JVyh",
	"./play-store.png": "6hIX",
	"./price-bg-blue.png": "RZDV",
	"./price-bg.png": "pR8Y",
	"./price-blue.png": "hTx2",
	"./price.png": "bt7z",
	"./screen1.png": "rkxw",
	"./screenshot-bg-blue.png": "3DGJ",
	"./screenshot-bg.png": "8bdc",
	"./screenshot-mob.png": "AkL+",
	"./star.png": "FHDy",
	"./team-bg-blue.png": "2PMg",
	"./team-bg.png": "nW+u",
	"./team-blue.png": "m0Jp",
	"./team-img-bg-blue.png": "Ktb/",
	"./team-img-bg.png": "ZRVw",
	"./team.png": "QyPm",
	"./team/1.jpg": "lZl/",
	"./team/10.jpg": "R2vR",
	"./team/11.jpg": "zoT4",
	"./team/11.png": "hI9p",
	"./team/12.jpg": "L9h+",
	"./team/2.jpg": "jPjf",
	"./team/3.jpg": "IWkz",
	"./team/4.jpg": "c5iQ",
	"./team/5.jpg": "CxFh",
	"./team/6.jpg": "yfRu",
	"./team/7.jpg": "ECfN",
	"./team/8.jpg": "zvCP",
	"./team/9.jpg": "wiGM",
	"./team/empty.jpg": "pP1+",
	"./team1-blue.png": "WHsu",
	"./team1.png": "wu6y",
	"./team3-blue.png": "TZai",
	"./team3.png": "1na9",
	"./telephone.png": "W8/8",
	"./testimonial-bg.png": "piVB",
	"./tfLogo.png": "9NVA",
	"./tfLogo.svg": "cd46",
	"./thank-you.png": "191p"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 0